export function GoogleDriveIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="17" viewBox="0 0 20 17" fill="none">
      <path
        d="M1.92609 14.1919L2.76194 15.5563C2.93561 15.8435 3.18563 16.0694 3.47931 16.2339L6.47754 14.2332L6.483 11.3608L3.49097 10.092L0.494144 11.3507C0.49355 11.6683 0.580031 11.9862 0.753738 12.2734L1.92609 14.1919Z"
        fill="#0066DD"
      />
      <path
        d="M10.011 5.6276L10.1674 1.8859L7.0258 0.744385C6.73149 0.907873 6.48062 1.1329 6.30584 1.41955L0.757225 10.4287C0.582479 10.7154 0.494735 11.0329 0.494141 11.3506L6.483 11.3607L10.011 5.6276Z"
        fill="#00AD3C"
      />
      <path
        d="M10.0106 5.62754L12.8885 4.17041L13.0142 0.754391C12.7206 0.589925 12.3831 0.507377 12.0347 0.506783L8.00588 0.500003C7.65742 0.499409 7.3197 0.591078 7.02539 0.744326L10.0106 5.62754Z"
        fill="#00831E"
      />
      <path
        d="M13.5173 11.3725L6.48315 11.3607L3.47949 16.2338C3.77317 16.3983 4.1106 16.4808 4.45901 16.4814L15.522 16.5C15.8705 16.5006 16.2082 16.409 16.5025 16.2557L16.5142 12.9825L13.5173 11.3725Z"
        fill="#0084FF"
      />
      <path
        d="M16.5026 16.2557C16.7969 16.0922 17.0477 15.8672 17.2225 15.5805L17.572 15.0175L19.2432 12.3045C19.4179 12.0178 19.5057 11.7003 19.5063 11.3826L16.0447 9.66833L13.5283 11.3726L16.5026 16.2557Z"
        fill="#FF4131"
      />
      <path
        d="M16.489 5.9458L13.7318 1.43188C13.5582 1.14461 13.3082 0.918739 13.0144 0.754272L10.0107 5.62742L13.5169 11.3724L19.4949 11.3825C19.4955 11.0648 19.409 10.7469 19.2353 10.4596L16.489 5.9458Z"
        fill="#FFBA00"
      />
    </svg>
  );
}
